var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 124,
    r: 124,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.875 89.6164C191.229 83.4664 186.396 78.6334 180.246 76.9871C169.098 74.0002 124.425 74.0002 124.425 74.0002C124.425 74.0002 79.7521 74.0002 68.6162 76.9871C62.4661 78.6334 57.6331 83.4664 55.9868 89.6164C53 100.752 53 124 53 124C53 124 53 147.248 55.9868 158.384C57.6331 164.534 62.4661 169.367 68.6162 171.013C79.7521 174 124.425 174 124.425 174C124.425 174 169.098 174 180.234 171.013C186.384 169.367 191.217 164.534 192.864 158.384C195.85 147.248 195.85 124 195.85 124C195.85 124 195.85 100.752 192.864 89.6164H192.875Z",
    fill: "#8091B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.62 145.254V102.747L147.447 124.001L110.62 145.254Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 141.708,
    height: 99.2,
    fill: "white",
    transform: "translate(53.9395 74.4006)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.ccdf9f9fbf250f3c0247f6bd9e9e35f6.svg";
export { ForwardRef as ReactComponent };